import { createContext, useContext } from "react";

import { type GetCategoryDataReturn } from "@/stf.data/request.product-private";

interface ProductListContextProps
  extends Pick<GetCategoryDataReturn, "categoryAttribute" | "categoryVariant"> {
  fixedRange: {
    searchSlug: string;
    urlSlug: string;
  }[];
  hierarchicalMenuAttributes: string[];
  sortByItems: {
    label: string;
    value: string;
    slug: string;
  }[];
}

const ProductListContext = createContext<ProductListContextProps | null>(null);

const useProductListContext = () => {
  const context = useContext(ProductListContext);

  if (!context) {
    throw new Error("useProductListContext must be used within a ProductListContextProvider ");
  }

  return context;
};

export {
  ProductListContext,
  type ProductListContextProps,
  useProductListContext,
};
